import React from 'react';
import { t } from 'i18next';
import { Box, Button, DialogContent, DialogTitle, Typography } from '@mui/material';

import Markdown from '../markdown';

const Acceptance = (props) => {
    const { studentName, term, handleBack, handleConfirm } = props;

    return (
        <>
            <DialogTitle>{t('AcceptDecline.Header2')}</DialogTitle>
            <DialogContent>
                <Box>
                    <Box sx={{ textAlign: 'left', marginBottom: '15rem' }}>
                        <Markdown>{t('AcceptDecline.AcceptExplanation', { StudentName: studentName, Term: term })}</Markdown>
                    </Box>
                </Box>

                <Box>
                    <Button
                        onClick={handleBack}
                        variant="contained"
                        sx={{ marginRight: '1rem' }}
                        color="secondary"
                    >
                        Back
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        variant="contained"
                    >
                        <Typography>Accept scholarship</Typography>
                    </Button>
                </Box>
            </DialogContent>
        </>
    );
};

export default Acceptance;
